import * as THREE from "three";
import * as TWEEN from "@tweenjs/tween.js";
import { ArcballControls } from "three/examples/jsm/Addons";
import { Colors } from "../colors";

export class Visualisation {
  static fillColorBufferAttribute(bufferAttribute, color) {
    const { array } = bufferAttribute;
    for (let i = 0; i < array.length; i += 3) {
      array[i] = color.r;
      array[i + 1] = color.g;
      array[i + 2] = color.b;
    }
    return bufferAttribute;
  }

  constructor(element) {
    this.element = element;
    this.scene = new THREE.Scene();
    this.camera = new THREE.PerspectiveCamera();
    this.updateCamera();
    this.controls = new ArcballControls(this.camera, this.element);
    this.sceneBounds = new THREE.Box3();
    this.sceneBoundsSize = new THREE.Vector3();
    this.sceneBoundsCenter = new THREE.Vector3();
    this.directionalLight = new THREE.DirectionalLight(
      THREE.Color.NAMES.white,
      2.0
    );
    this.ambientLight = new THREE.AmbientLight(Colors.gray, 0.5);
    this.scene.add(this.directionalLight, this.ambientLight);
  }

  dispose() {
    this.controls.dispose();
    this.scene.clear();
  }

  onMouseDown() {}
  onMouseUp() {}
  onMouseMove() {}
  onMouseLeave() {}

  moveToAndLookAt(newPos, newTarget) {
    const positionTween = new TWEEN.Tween(this.camera.position)
      .to(
        {
          x: newPos.x,
          y: newPos.y,
          z: newPos.z,
        },
        1000
      )
      .easing(TWEEN.Easing.Quadratic.InOut);
    const targetTween = new TWEEN.Tween(this.controls.target)
      .to(
        {
          x: newTarget.x,
          y: newTarget.y,
          z: newTarget.z,
        },
        1000
      )
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onUpdate(() => {
        this.controls.update();
      });
    positionTween.start();
    targetTween.start();
  }

  lookAtScene() {
    this.camera.position.set(0, 0, 0);
    this.controls.reset();
    this.controls.update();

    this.sceneBounds.setFromObject(this.scene);
    this.sceneBounds.getSize(this.sceneBoundsSize);
    this.sceneBounds.getCenter(this.sceneBoundsCenter);
    const maxDim = Math.max(
      this.sceneBoundsSize.x,
      this.sceneBoundsSize.y,
      this.sceneBoundsSize.z
    );
    const fov = this.camera.fov * (Math.PI / 180);
    const cameraDistance = maxDim / (2 * Math.tan(fov / 2));

    this.camera.position.set(
      this.sceneBoundsCenter.x,
      this.sceneBoundsCenter.y,
      this.sceneBoundsCenter.z + cameraDistance
    );
    this.controls.target.copy(this.sceneBoundsCenter);
    this.controls.update();
  }

  updateCamera() {
    this.camera.fov = 30;
    this.camera.aspect = this.element.clientWidth / this.element.clientHeight;
    this.camera.near = 0.01;
    this.camera.far = 2000;
    this.camera.updateProjectionMatrix();
    if (this.controls) {
      this.controls.update();
    }
  }
}
